import React from 'react';
import { apiPost } from '../../../../../services/apiClient';
import SelectInput from '../../../../../controls/selectInput.jsx';

export default class DocumentTypeCell extends React.Component {
    constructor(args) {
        super(args);

		let items = this.convertItems(this.props.items);
		let label = this.findLabelForValue(this.props.value, items);
        this.state = {
            value: this.props.value,
            label: label,
            items: items,
			error: null,
			isBusy: false,
			isEdit: false
        };
    }

    componentWillReceiveProps(newProps) {
		let items = this.convertItems(newProps.items);
		let label = this.findLabelForValue(newProps.value, items);
        this.setState({ 
			value: newProps.value,
            label: label,
            items: items
		});
    }

	findLabelForValue(value, items) {
		let result = '';
		if (items) {
			items.forEach((item, ind, arr) => {
				if (item.value === value) {
					result = item.label;
				}
			});
		}
		return result;
	}

	convertItems(items) {
		return items.map((item, ind, array) => { return { value: item.id, label: item.name }; });
	}

	handleTypeChange(selection) {
		if (selection) {
			this.setState({ 
				value: selection.value,
				label: selection.label,
				isBusy: true 
			});
			let request = {
				documentType: selection.value
			};
			apiPost("parcels/documents/" + this.props.parcelId + "/file/" + this.props.documentId + "/type", request)
				.then(() => {
					this.setState({
						error: null,
						isBusy: false,
						isEdit: false
					});
				})
				.catch(err => {
					let error = err.messages ? err.messages.documentType : null;
					this.setState({
						error: error,
						isBusy: false
					});
				});
		} else {
			this.setState({ isEdit: false });
		}
	}

	handleLostFocus() {
		this.setState({ isEdit: false });
	}

	enableEditState() {
		if (this.props.isEditable) {
			this.setState(
				{ isEdit: true }, 
				() => {
					$('#parcelDocumentTypeEditor').focus();
				}
			);
		}
	}

	renderLabel() {
		return (
			<div onClick={() => this.enableEditState()}>
				{this.state.label}
			</div>
		);
	}

	renderEditor() {
		return (
			<td className={"form-group" + (this.state.error ? " has-error" : "")}>
                <SelectInput id="parcelDocumentTypeEditor"
                    options={this.state.items}
                    value={this.state.value}
					title={this.props.errors}
                    onChange={e => this.handleTypeChange(e)}
                    onBlur={e => this.handleLostFocus()}
					disabled={this.state.isBusy}
					clearable={false}
                />
			</td>
		);
	}

	render() {
		if (this.state.isEdit) {
			return this.renderEditor();
		} else {
			return this.renderLabel();
		}
	}
}


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/tabs/controls/docTypeCell.jsx